import { useEffect, useRef } from 'react';

// Invalidate in render so even the first render of a new subject hides old data.
export default function useEvaluationRequestScope(key) {
  const scope = useRef({ key, generation: 0 });
  if (scope.current.key !== key) {
    scope.current = { key, generation: scope.current.generation + 1 };
  }
  useEffect(() => () => { scope.current.generation += 1; }, [key]);
  const begin = () => {
    const generation = ++scope.current.generation;
    return () => scope.current.key === key && scope.current.generation === generation;
  };
  const capture = () => {
    const generation = scope.current.generation;
    return () => scope.current.key === key && scope.current.generation === generation;
  };
  return { begin, capture };
}

// Fail closed if an API response does not match the requested subject.
export function scopedEvaluationResults(response, user, year, form) {
  const results = response?.data?.results;
  if (!Array.isArray(results)) return [];
  return results.filter(record =>
    String(record?.user?.id ?? record?.user) === String(user) &&
    String(record?.year?.year ?? record?.year) === String(year) &&
    String(record?.apa_form?.id ?? record?.apa_form) === String(form)
  );
}
